// @-mention autocomplete for comment textareas. Progressive enhancement, no
// framework: reads the mentionable names from data-mentions, shows a filtering
// dropdown when the caret is inside an @token, and inserts the picked name.
//
// Matches the server-side MentionScanner (which resolves by first name / full
// name), so inserting "@Firstname " reliably notifies that teammate.

function initMentions(root) {
  const input = root.querySelector("[data-mention-input]");
  const list = root.querySelector("[data-mention-list]");
  if (!input || !list || input.dataset.mentionBound) return;
  input.dataset.mentionBound = "true";

  let names = [];
  try { names = JSON.parse(input.dataset.mentions || "[]"); } catch { names = []; }
  if (!names.length) return;

  let active = -1;
  let matches = [];

  // The @token immediately before the caret, or null. Token = word chars/dots.
  function currentToken() {
    const pos = input.selectionStart;
    const upto = input.value.slice(0, pos);
    const m = upto.match(/@([\w.]*)$/);
    if (!m) return null;
    return { query: m[1].toLowerCase(), start: pos - m[1].length - 1, end: pos };
  }

  function close() { list.classList.add("hidden"); list.innerHTML = ""; active = -1; matches = []; }

  function render(token) {
    // Prefix match on the full name or any name part (so "@f" → Felix, not Okafor).
    const q = token.query;
    matches = names
      .filter((n) => {
        const lower = n.toLowerCase();
        return lower.replace(/[\s.]/g, "").startsWith(q) || lower.split(/\s+/).some((w) => w.startsWith(q));
      })
      .slice(0, 8);
    if (!matches.length) return close();

    list.innerHTML = matches
      .map((n, i) => `<li><a class="${i === active ? "active" : ""}" data-i="${i}">${n}</a></li>`)
      .join("");
    list.classList.remove("hidden");
  }

  function insert(name) {
    const token = currentToken();
    if (!token) return;
    const first = name.split(/\s+/)[0];
    const before = input.value.slice(0, token.start);
    const after = input.value.slice(token.end);
    input.value = `${before}@${first} ${after}`;
    const caret = before.length + first.length + 2;
    input.setSelectionRange(caret, caret);
    close();
    input.focus();
  }

  input.addEventListener("input", () => {
    const token = currentToken();
    if (token) { active = 0; render(token); } else { close(); }
  });

  input.addEventListener("keydown", (e) => {
    if (list.classList.contains("hidden")) return;
    if (e.key === "ArrowDown") { e.preventDefault(); active = (active + 1) % matches.length; render(currentToken() || { query: "" }); }
    else if (e.key === "ArrowUp") { e.preventDefault(); active = (active - 1 + matches.length) % matches.length; render(currentToken() || { query: "" }); }
    else if (e.key === "Enter" && active >= 0) { e.preventDefault(); insert(matches[active]); }
    else if (e.key === "Escape") { close(); }
  });

  list.addEventListener("mousedown", (e) => {
    const li = e.target.closest("[data-i]");
    if (li) { e.preventDefault(); insert(matches[Number(li.dataset.i)]); }
  });

  input.addEventListener("blur", () => setTimeout(close, 150));
}

function initAll() {
  document.querySelectorAll("[data-mention-root]").forEach(initMentions);
}

document.addEventListener("turbo:load", initAll);
document.addEventListener("DOMContentLoaded", initAll);
